import { loader } from 'graphql.macro'

export default function haulerQuery ({ dataLoaders }) {
  const haulerQuery = loader('./hauler.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(haulerQuery)
    .then(data => data.user.hauler)
}
